import { ref as S, computed as i, useId as P, withDirectives as _, openBlock as p, createElementBlock as f, normalizeClass as c, withKeys as m, createElementVNode as r, unref as a, toDisplayString as b, withModifiers as W, createBlock as X, createCommentVNode as B, createVNode as $, Transition as Y, withCtx as z, normalizeStyle as E, renderSlot as F, Fragment as H, renderList as M, vShow as q } from "vue";
import { themeProp as R } from "../../composables/useTheme.js";
import { useTracking as G } from "../../composables/useTracking.js";
import J from "../../utils/directives/click-outside.js";
/* empty css              */
import Q from "../../_virtual/_plugin-vue_export-helper.js";
import C from "../../atoms/icon/icon.vue.js";
const U = ["id"], Z = { class: "ds-dropdown__wrapper" }, tt = ["aria-controls", "aria-labelledby", "aria-expanded", "data-track-component-name", "data-track-text"], et = ["id", "aria-labelledby"], ot = ["id", "data-track-component-name", "data-track-text", "onClick", "onKeydown"], nt = { class: "ds-dropdown__list__option__text ds-text" }, D = "DsDropdown", at = /* @__PURE__ */ Object.assign({
  name: D
}, {
  __name: "dropdown",
  props: {
    ...R,
    /**
     * trackingData, to be set as data-track attributes for tracking purpose
     * Will take precedence over `trackingDataProvided` injected by the `tracking` mixin
     */
    trackingData: {
      type: Object,
      default: () => ({})
    },
    /**
     * Dropdown label, describes the dropdown usage.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Dropdown button text.
     */
    text: {
      type: String,
      required: !0
    },
    /**
     * Dropdown withBoldText, makes the button font style bold.
     */
    withBoldText: {
      type: Boolean,
      default: !1
    },
    /**
     * Dropdown withBorder, makes the button style bordered.
     */
    withBorder: {
      type: Boolean,
      default: !1
    },
    /**
     * Dropdown button icon, button left sided icon.
     */
    icon: {
      type: Object,
      default: null
    },
    /**
     * Dropdown options
     */
    options: {
      type: Array,
      default: () => []
    },
    /**
     * Dropdown popover height, will overwrite the default popover height.
     */
    height: {
      type: String,
      default: "auto"
    },
    /**
     * Dropdown popover width, will overwrite the default popover width.
     */
    width: {
      type: String,
      default: "auto"
    },
    /**
     * Dropdown full screen popover width, will overwrite the popover width.
     */
    fullScreen: {
      type: Boolean,
      default: !1
    },
    /**
     * Dropdown popover alignment on y-axis relative to the button element.
     * Possible values are: 'top' and 'bottom'.
     */
    alignY: {
      type: String,
      default: "bottom",
      validator: (t) => ["top", "bottom"].includes(t)
    },
    /**
     * Dropdown popover alignment on x-axis relative to the button element.
     * Possible values are: 'left' and 'right'.
     */
    alignX: {
      type: String,
      default: "left",
      validator: (t) => ["left", "right"].includes(t)
    },
    closeOnClickOutside: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["dropdown-opened", "dropdown-closed", "dropdown-item-clicked"],
  setup(t, { emit: O }) {
    const o = t, n = S(!1), w = S(null), h = O, { trackingDataProvided: j } = G(), T = i(() => o.width === "auto"), v = i(() => o.width === "100%"), N = i(() => ({
      left: o.alignX === "left" ? "0" : "auto",
      right: o.alignX === "right" ? "0" : "auto",
      top: o.alignY === "bottom" ? "100%" : "auto",
      bottom: o.alignY === "top" ? "100%" : "auto",
      height: K.value,
      width: o.width ? k(o.width, "auto") : "auto"
    })), I = i(() => o.options.length <= 5 ? "auto" : "260px"), K = i(
      () => o.options.length ? I.value : k(o.height, "auto")
    ), g = i(
      () => o.trackingData["component-name"] || j["component-name"] || D
    ), s = P(), x = () => {
      n.value || (n.value = !0, h("dropdown-opened", { label: o.text, setScrollTop: A }));
    }, d = (e) => {
      n.value && (n.value = !1, h("dropdown-closed", { label: e ? e.text : o.text }));
    }, V = () => {
      n.value ? d() : x();
    }, A = (e) => {
      w.value && (w.value.scrollTop = e);
    }, y = (e) => {
      d(e), h("dropdown-item-clicked", e);
    };
    function k(e, u) {
      return e ? !e.includes("px") && !e.includes("%") ? `${e}px` : e : u;
    }
    return (e, u) => _((p(), f("div", {
      class: c(["ds-dropdown", [
        `ds-dropdown--${e.theme}`,
        { "ds-dropdown--with-border": t.withBorder },
        { "ds-dropdown--full-width": v.value || t.withBorder || t.fullScreen }
      ]]),
      onKeydown: [
        m(d, ["esc"]),
        m(x, ["enter"])
      ]
    }, [
      r("label", {
        id: `dropdown-label-${a(s)}`,
        class: "ds-screen-reader-visible"
      }, b(t.label || t.text), 9, U),
      r("div", Z, [
        r("div", {
          "aria-controls": `dropdown-listbox-${a(s)}`,
          "aria-labelledby": `dropdown-label-${a(s)}`,
          "aria-expanded": n.value.toString(),
          class: c([{ "ds-dropdown__button--active": n.value }, "ds-dropdown__button"]),
          "aria-haspopup": "listbox",
          role: "combobox",
          tabindex: "0",
          "data-j-button": "",
          "data-track-component-name": g.value,
          "data-track-text": t.text,
          onMousedown: u[0] || (u[0] = W(() => {
          }, ["prevent"])),
          onClick: V
        }, [
          t.icon ? (p(), X(a(C), {
            key: 0,
            name: t.icon.name,
            category: t.icon.category,
            class: "ds-dropdown__button__icon"
          }, null, 8, ["name", "category"])) : B("", !0),
          r("span", {
            role: "textbox",
            class: c(["ds-text", { "ds-font-weight-bold": t.withBoldText }])
          }, b(t.text), 3),
          $(a(C), {
            name: t.withBorder ? "chevron-down" : "chevron-down-small",
            category: "arrows",
            class: "ds-dropdown__button__icon-chevron"
          }, null, 8, ["name"])
        ], 42, tt),
        $(Y, { name: "popover" }, {
          default: z(() => [
            _(r("div", {
              id: `dropdown-listbox-${a(s)}`,
              ref: w.value,
              "aria-labelledby": `dropdown-label-${a(s)}`,
              style: E(N.value),
              class: c([[
                `ds-popover-container--${e.theme}`,
                { "ds-popover-container--full-width": v.value && !t.withBorder || t.fullScreen }
              ], "ds-dropdown__list ds-popover-container"]),
              role: "listbox",
              tabindex: "-1",
              "data-j-content": ""
            }, [
              F(e.$slots, "default", { close: d }, () => [
                t.options ? (p(!0), f(H, { key: 0 }, M(t.options, (l) => (p(), f("div", {
                  id: l.id,
                  key: l.id,
                  class: c([[`ds-button-list-option--${e.theme}`, { "ds-dropdown__list__option--autoWidth": T.value }], "ds-dropdown__list__option ds-button-list-option"]),
                  role: "option",
                  "data-j-option": "",
                  "data-track-component-name": g.value,
                  "data-track-text": l.text,
                  onClick: (L) => y(l),
                  onKeydown: [
                    m((L) => y(l), ["enter"]),
                    m(d, ["tab"])
                  ]
                }, [
                  r("span", nt, b(l.text), 1)
                ], 42, ot))), 128)) : B("", !0)
              ], !0)
            ], 14, et), [
              [q, n.value]
            ])
          ]),
          _: 3
        })
      ])
    ], 34)), [
      [a(J), d]
    ]);
  }
}), pt = /* @__PURE__ */ Q(at, [["__scopeId", "data-v-0795720f"]]);
export {
  pt as default
};
